module.exports = __webpack_public_path__ + "static/media/cucina_classico.01fde755.jpg";